import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-activity-comment-icon',
  template: `<i *ngIf="title" class="fas fa-edit fa-md" [style]="style" [title]="title" aria-hidden="true"></i>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCommentIconComponent {
  @Input() title: string;
  @Input() componentStyle: string;

  private defaultComponentStyle = 'color: orange; padding-left: 5px;';

  constructor(private sanitizer: DomSanitizer) {}

  get style() {
    const style = this.componentStyle ? this.componentStyle : this.defaultComponentStyle;
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }
}
